import React, { useEffect, useState } from "react";
import ReactPlayer from "react-player";
import { Link } from "react-router-dom";
import Pending from "../../../../assets/images/pending 2.png";
import Clock from "../../../../assets/images/ClockBG.png";
import Banner from "../../../../assets/images/Rounds/statusTopBanner.png";
import LiN from "../../../../assets/images/Rounds/statusTopBanner.png";
import "./PendingPost.css";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import Slider from "react-slick";
import axios from "axios";
import swal from "sweetalert";
import { Markup } from "interweave";
import noImage from "../../../../assets/images/settings/no-image.png";
import LoaderPost from "../../../Reuseable/LoaderPost";
import AuditionCompletedView from "./CompleteAuditionSliderStar/AuditionCompletedView";
import { serverInfo } from "../../../../App";
import { useContext } from "react";

const PendingPromoAudition = () => {
  const { imageCdnUrl } = useContext(serverInfo);
  const [auditions, setAuditions] = useState([]);
  const [loading, setLoading] = useState(true);

  const getPendingPromoInstructionAudition = () => {
    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios
        .get(`/api/superstar/audition/promo-instruction-pending`)
        .then((res) => {
          if (res.data.status === 200) {
            setAuditions(res.data.auditions);
          }
        });
    });
    setLoading(false);
  };
  useEffect(async () => {
    getPendingPromoInstructionAudition();
  }, []);

  return (
    <>
      {loading === true ? (
        <LoaderPost />
      ) : (
        <>
          <div className=" row ">
            <div
              title="Live Now"
              className="col-md-2 align-items-center justify-content-center Souvenir-bt "
            >
              <div className="card meetupCard">
                <div className="card-body  align-items-center">
                  <center>
                    <tr>
                      <td className="ad-card-td">
                        <img
                          src={Pending}
                          className="ad-card-img-top"
                          alt="..."
                        />
                      </td>
                      <td className="ad-card-td">
                        <small className="ad-card-small"></small>

                        <small className="ad-card-small">
                          {auditions && auditions.length}
                        </small>
                      </td>
                    </tr>
                  </center>
                </div>
                {/* <Link to="/superstar/audition/live"> */}
                <button
                  className="card-footer Souvenir-button  w-100 "
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseOne"
                  aria-expanded="true"
                  aria-controls="collapseOne"
                >
                  {" "}
                  Pending Promo Instruction
                </button>
                {/* </Link> */}
              </div>
            </div>
          </div>

          <AuditionCompletedView />

          <div className="row liveMeetupBorder my-3 mx-2">
            <div className="d-flex px-4 pt-3">
              <div className="faTrophy">
                <i className="fas fa-trophy"></i>
              </div>
              <h4 className="mx-3 text-white p-2">
                {" "}
                Pending Promo Instruction
              </h4>
            </div>
            <div className="">
              <div className="slick-parent d-flex justify-content-center">
                {/* pendig aution list */}
                {auditions.map((audition, index) => (
                  <div className="p-3" key={index}>
                    <div className="sliderCardBorder">
                      <img
                        src={
                          audition?.banner
                            ? imageCdnUrl+audition?.banner
                            : noImage
                        }
                        // src={LiN}
                        className="img-fluid"
                        alt=""
                        style={{
                          height: "200px",
                          width: "300px",
                        }}
                      />
                      <div className="p-3">
                        <h5 className="text-white text-center title-limit">
                          {audition?.title}
                        </h5>

                        <p className="text-light">
                          <Markup content={audition?.description} />
                        </p>
                        {audition?.assigned_judges[0]?.user
                          ?.assigned_to_me_promo_instruction_send_info ? (
                          <>
                            <Link
                              to={`/superstar/audition/promo-instruction-send-info/${audition?.assigned_judges[0]?.user?.assigned_to_me_promo_instruction_send_info.id}`}
                              className="Link"
                            >
                              <button className="btn btn-done w-100 fw-bold mt-2">
                                Action
                              </button>
                            </Link>
                          </>
                        ) : (
                          <>
                            <button
                              disabled={true}
                              className="btn btn-done w-100 fw-bold mt-2"
                            >
                              Action
                            </button>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default PendingPromoAudition;
